import type { UserProfileData } from '../domain/types'
import type { UserProfileAPIResponse } from './types'

export function userProfileMapper(apiResponse: UserProfileAPIResponse): UserProfileData {
  const firstName = apiResponse.firstName?.trim() || ''
  const lastName = apiResponse.lastName?.trim() || ''
  const birthDate = apiResponse.birthDateUnformatted?.trim() || ''
  return {
    firstName,
    lastName,
    birthDate,
  }
}
